
export default {
    IMAGES : 'images',
    JOKES : 'jokes',
    ALL : 'all'
}
